import { type ReactNode } from 'react';

interface PageContentProps {
    children: ReactNode;
    className?: string;
}

export function PageContent({ children, className }: PageContentProps) {
    return <div className={`space-y-4 p-4 ${className || ''}`}>{children}</div>;
}
